import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  hasMore: false,
  searchresult: null,
};

const slice = createSlice({
  name: 'campus',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // HAS MORE
    noHasMore(state) {
      state.hasMore = false;
    },
    // GET SEARCH RESULTS
    getSearchResultSuccess(state, action) {
      state.isLoading = false;
      state.searchresult = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;